import React from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { Container, Row, Col } from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import { connect } from 'react-redux';
import {
  changeHandler,
  validateHandler,
  clearIsValid,
  setReceivingAd,
  setReceivingBill,
  emailIsExist,
  clearValid,
  reportAnalytics,
} from './PersonalInfoSlice';
import CheckBox from '../../../Shared/CheckBox/Checkbox';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import ThirdParty from '../../../Shared/ThirdParty/ThirdParty';

const personalInfo = (props) => {
  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.onSubmit) {
          props.validateHandler(props.form);
          props.onValid(false);
        }
      }
    },
    [props.onSubmit]
  );

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
    }
    switch (props.saletype) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: 'visibility_22',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'app':
        props.reportAnalytics({
          eventCategory: 'app_newsale_process',
          eventAction: 'visibility_30',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
      case 'cellular':
        props.reportAnalytics({
          eventCategory: 'cellular_newsale_process',
          eventAction: 'visibility_25',
          eventLabel: 'screen_15',
        });
        break;
      case 'internet':
        props.reportAnalytics({
          eventCategory: 'fiber_newsale_process',
          eventAction: 'visibility_18',
          eventLabel: props.productsInfo.selectedProducts[0]?.name,
        });
        break;
    }
  }, []);

  // useExtendedEffect(
  //   (runSideEffects) => {
  //     if (runSideEffects()) {
  //     }
  //     if (props.form.id === '' && props.customerId != undefined) {
  //       props.setId(props.customerId);
  //     }
  //   },
  //   [props.form.id]
  // );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if ((props.form.valid && props.saletype === 'tv') || (props.form.valid && props.saletype === 'app')) {
          getCaptchaandCheckEmail();
        }
      }
    },
    [props.form.valid]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if ((props.saletype === 'tv' && props.isEmailFree) || (props.saletype === 'app' && props.isEmailFree)) {
          props.clearValid();
          props.onValid(true);
        } else {
          props.onValid(false);
        }
      }
    },
    [props.isEmailFree]
  );

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.saletype != 'tv' && props.saletype != 'app') {
          if (props.form.valid) {
            props.clearValid();
            props.onValid(true);
          }
        }
      }
    },
    [props.form.valid]
  );

  async function getCaptchaandCheckEmail() {
    props.emailIsExist({ eMailAddress: props.form.email });
  }

  return (
    <Container className='personal-inf'>
      <Row>
        <Col>
          <section className='personal-inf-form'>
            <span className='note-text'>שדות עם כוכבית הם חובה</span>
            <TextInput
              required={true}
              name='firstName'
              type='text'
              placeholder='שם פרטי'
              autoComplete='off'
              role='input first name'
              value={props.form.firstName}
              error={props.form.errors.firstName}
              onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
            />
            <TextInput
              required={true}
              name='lastName'
              type='text'
              placeholder='שם משפחה'
              autoComplete='off'
              role='input last name'
              value={props.form.lastName}
              error={props.form.errors.lastName}
              onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
            />

            {/* <TextInput
              required={true}
              disabled={props.customerId || props.isDisableIdentity ? true : false}
              name='id'
              type='number'
              pattern='[0-9]*'
              placeholder='ת״ז'
              autoComplete='off'
              role='input id'
              maxLength='9'
              value={props.form.id}
              error={props.form.errors.id}
              onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
            /> */}

            <TextInput
              required={true}
              name='email'
              type='email'
              placeholder='מייל'
              autoComplete='off'
              role='input email'
              value={props.form.email}
              error={props.form.errors.email}
              onChange={(e) => props.changeHandler({ target: e.target, form: props.form })}
            />
            {props.isEmailFree === false ? <div className='existedEmail'>קיים כבר מנוי TV על המייל הזה, יש מייל אחר?</div> : null}
            {props.saletype == 'tv' ? <span className='email-note'>כתובת הדואל תשמש אותכם ל{window.Config.brand_Name_HE} TV</span> : null}
            <div className='checkboxes'>

              {props.saletype != 'tv' && props.saletype != 'app' ? (
                <Row className='approve-receiving'>
                  <Col xs='1' md='1'>
                    <div>
                      <CheckBox
                        checked={props.isReceivingBill}
                        id='approveReceivingBills'
                        onCheck={(e) => props.setReceivingBill({ target: e.target, receiveMsgs: props.isReceivingBill })}
                        onUncheck={(e) => props.setReceivingBill({ target: e.target, receiveMsgs: props.isReceivingBill })}></CheckBox>
                    </div>
                  </Col>
                  <Col xs='10' md='11'>
                    <label htmlFor='approveReceivingBills'>
                      אני רוצה לקבל את החשבונית למייל שהזנתי (במקרה בו תסיר את הסימון,  תשלח החשבונית לכתובת המגורים שמילאת)
                    </label>
                  </Col>
                </Row>
              ) : null}

              {props.saletype != 'internet' ? (
                <Row className='approve-receiving'>
                  <Col xs='1' md='1'>
                    <div>
                      <CheckBox
                        checked={props.isReceivingAd}
                        id='approveReceivingMsg'
                        onCheck={(e) => props.setReceivingAd({ target: e.target, receiveMsgs: props.isReceivingAd })}
                        onUncheck={(e) => props.setReceivingAd({ target: e.target, receiveMsgs: props.isReceivingAd })}></CheckBox>
                    </div>
                  </Col>
                  <Col xs='10' md='11'>
                    {/* <label htmlFor='approveReceivingMsg'> אני מאשר/ת קבלת דברי פרסומת מסלקום ושותפיה העסקיים, ושיתוף מידע כמפורט להלן (גם אם לא תסמן, נשלח פרסומות לשירותינו בלבד, אלא אם ביקשת הסרה) <a href='#' onClick={() => buildUrlAndOpenWindow(props.advertisingInfoLink)}>המשך</a> </label> */}
                    <label htmlFor='approveReceivingMsg'><ThirdParty/></label>
                  </Col>
                </Row>
              ) : null}

            </div>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.PersonalInfo.form,
    isReceivingAd: state.PersonalInfo.isReceivingAd,
    isReceivingBill: state.PersonalInfo.isReceivingBill,
    isEmailFree: state.PersonalInfo.isEmailFree,
    productsInfo: state.saleBlock.productsInfo,
    advertisingInfoLink: state.saleBlock.epiServer.saleBlock.advertisingInfoLink,
  };
};

const mapDispatchToProps = {
  changeHandler,
  validateHandler,
  clearIsValid,
  setReceivingAd,
  setReceivingBill,
  //setId,
  emailIsExist,
  clearValid,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(personalInfo);
